import axios from "axios";
import * as d3 from "d3";
import {colonAnnotation, fw_progressive_1way, numberFormat, responsivefy, tooltip_class} from '../functions'

export default function (chart, divId, vizName, filterParam, checkbox) {
    var size = chart.axisFontSize
    var fontSize = size+"px"
    var fontColor = chart.axisFontColor
    var axisLabelFontSize = chart.axisLabelFontSize+ "px"
    //var tempVar = chart.tempVar

    var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName)

    var svg = d3.select(divId).select("svg").remove();
    svg = d3.select(divId)
        .append('svg')
        .attr('width', chart.width + chart.margin.left + chart.margin.right)
        .attr('height', chart.height + chart.margin.top + chart.margin.bottom)
        .call(responsivefy)
        .append('g')
        .attr('transform', 'translate(' + chart.margin.left + ',' + chart.margin.top + ')')

    axios.post(url, filterParam).then(response => {
        let data = response.data
        console.log("XDIM",data)
        // nest function allows to group the calculation per level of a factor
        var sumstat = d3.nest().key(d =>{ return d.dim1_name }).sortKeys(d3.ascending).entries(data)
        // Add X-axis for date and Y-axis
        var x1Scale= d3.scaleBand().rangeRound([0, chart.width]).domain(data.map((d) =>{ return d.dim2_name }));
        var y1Scale = d3.scaleLinear()
            .domain(d3.extent(data, function(d) { return d.metric1; }))
            .range([chart.height, 0])


        // var lineess=data.map(function(d){ return  d.dim2_name })
        //
        // console.log(lineess)
        //
        // var dataTitles = lineess.filter(function(item){ return item.endsWith('LPSD')  })
        //
        // console.log(dataTitles)
        //
        // var lineStart = dataTitles[0]


        const results = data.filter(obj => {
            return obj.dim3_name === "1";
        });

        console.log("Result",results)

        var lineStart = results[0].dim2_name

        console.log("Line start",lineStart)



        svg.append('g')
            .attr('transform', 'translate(0,' + chart.height + ')')
            .call(d3.axisBottom(x1Scale))
            //.call(d3.axisBottom(x1Scale))
            .selectAll('text')
            .style('font-size',axisLabelFontSize)
            .style('font-weight','bolder')
            .style('fill', fontColor)
            .style('text-anchor', 'end')
            .attr('dx', '-.8em')
            .attr('dy', '-.20em')
            .attr('transform', 'rotate(-60)')

        svg.append('text')
            .attr('x', 10)
            .attr('y', chart.height+ chart.margin.bottom- 5-chart.axisLabelDistance)
            .style('fill', fontColor)
            .text(chart.x1AxisDisplayName)
            .style('font-size',fontSize)

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', 0 - chart.margin.left)
            .attr('x', 0 - (chart.height / 2))
            .attr('dy', '1em')
            .style('text-anchor', 'middle')
            .style('fill', fontColor)
            .text(chart.y1AxisDisplayName)
            .style('font-size',fontSize)

        svg.append('g')
            //  .attr('display','none')
            .call(d3.axisLeft(y1Scale).tickFormat(numberFormat))
            .selectAll('text')
            .style('font-size',axisLabelFontSize)
            .style('font-weight','bolder')
            .style('fill', fontColor)

        // color palette
        var res = sumstat.map(d =>{ return d.key }) // list of group main category
        var metric1ColorScale = d3.scaleOrdinal().domain(res).range(fw_progressive_1way)

        // Draw the line
        svg.selectAll('.line')
            .data(sumstat)
            .enter()
            .append('path')
            .attr('fill', 'none')
            .attr('stroke', d =>{ return metric1ColorScale(d.key) })
            .attr('stroke-width', 3)
            .attr('d', (d) => {
                let line = d3.line()
                    .x(d => { return x1Scale(d.dim2_name) + 50 })
                    .y(d => { return y1Scale(+d.metric1) })

                return line(d.values)
            })
        //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding

        var line = svg.append("line")
            .attr("display",function(){ return checkbox == false ? "block" :"none"})
            .attr("x1", x1Scale(lineStart))
            .attr("x2", x1Scale(lineStart))
            .attr("y1", chart.height)
            .attr("y2", 0)
            .style("stroke", "black")
            .style("stroke-width", 5)
            .style("stroke-dasharray", "9,6")

        console.log(line)

        //Add text to the top of the vertical Line
        svg.append("text")
            .attr("y", -5)//magic number here
            .attr("x", function(){ return x1Scale(lineStart)})
            .attr('text-anchor', 'middle')
            .attr("class", "myLabel")//easy to style with CSS
            .text(chart.vizSpecific4);


        // Add the dots for the tooltip
        d3.select(".d3-tip"+divId.id).remove(); // clear tooltip based on class of tip element // appended with divId to make it unique
        var y1tip = tooltip_class()

        y1tip.attr('class', 'd3-tip'+divId.id)
            .html((d)=> {
                return chart.x1MetricTooltip+ colonAnnotation+ d.dim2_name+ "<br/>"+ chart.x2MetricTooltip
                    + colonAnnotation+ d.dim1_name+ "<br/>" +chart.y1MetricTooltip + colonAnnotation+ numberFormat(d.metric1)
            })

        svg.call(y1tip);

        svg.selectAll("dot")
            .data(data)
            .enter()
            .append("circle")
            .attr("r", 5)
            .attr("cx", function(d) { return x1Scale(d.dim2_name) + 50; })
            .attr("cy", function(d) { return y1Scale(d.metric1); })
            .style("fill", d =>{ return metric1ColorScale(d.dim1_name) })
            //.attr("id", 'tag'+d.key.replace(/\s+/g, '')) // assign ID
            .on("mouseover", y1tip.show)
            .on("mouseout", y1tip.hide)



        svg.append("g").selectAll('text')
            .data(data)
            .enter()
            .append('text')
            .attr('text-anchor', 'middle')
            .attr("x", function(d) { return x1Scale(d.dim2_name) + 50; })
            .attr("y", function(d) { return y1Scale(d.metric1) - 10; })
            .text(function(d){ return numberFormat(d.metric1)})
            .style('font-size',axisLabelFontSize)

        var y1legend = svg.append('g')
            .selectAll('g')
            .data(sumstat)
            .enter()
            .append('g')
            .attr('class', 'legend')
            .attr('transform', (d, i) => 'translate(0,' + i * 25 + ')')

        y1legend.append('circle')
            .attr('cx', chart.width + chart.vizSpecific2 - 30)
            .attr('cy', 20)
            .attr('r', 7)
            .attr('dy', '0.75em')
            .attr('fill', d =>{ return metric1ColorScale(d.key) })

        y1legend.append('text')
            .data(sumstat, d => { return d.key })
            .attr('x', chart.width + chart.vizSpecific2-8)
            .attr('y', 10)
            .attr('dy', '0.8em')
            .text((d) =>{ return d.key  })
            .style('font-size',axisLabelFontSize)
    })
}
